import * as TYPES from './clinicTypes';

const INITIAL_STATE = {
  clinic: {},
  selectedClinic: null,
  showLoading: false,
  errorMessage: '',
};

export default (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TYPES.SELECT_CLINIC:
      return {
        ...state,
        selectedClinic: action.date,
      };
    case TYPES.GET_ALL_CLINIC_REQUEST:
      return {
        ...state,
        showLoading: true,
      };
    case TYPES.GET_ALL_CLINIC_SUCCESS: {
      const clinic = {};
      action.data.forEach(key => {
        clinic[key] = [];
      });
      return {
        ...state,
        clinic,
        errorMessage: '',
        showLoading: false,
      };
    }
    case TYPES.GET_ALL_CLINIC_FAILURE:
      return {
        ...state,
        clinic: {},
        errorMessage: action.errorMessage,
      };
    case TYPES.GET_DETAIL_CLINIC_BY_DATE_SUCCESS: {
      const clinic = { ...state.clinic };
      clinic[state.selectedClinic] = action.data;
      return {
        ...state,
        clinic,
        errorMessage: '',
      };
    }
    case TYPES.SHOW_LOADING:
      return { ...state, showLoading: true };
    case TYPES.HIDE_LOADING:
      return { ...state, showLoading: false };
    default:
      return state;
  }
};
